import { Provider } from 'react-redux'
import React from 'react'
import pluginComponents from '../../utils/pluginComponents'

const PluginProvider = props => (
  <Provider store={props.store}>{pluginComponents(props.type)}</Provider>
)

export default PluginProvider
